;
(function() {
  var snTrackEventsModule = function () {
    var self = this;

    return {
      trackEvent: function(sampleKitId, category, action, label, value, customData) {
        this._pushToDb(sampleKitId, category, action, label, value, customData);
      },

      _pushToDb: function(sampleKitId, category, action, label, value, customData) {
        $.ajax({
          url : window.site.urls.api + '/events/track',
          type: "POST",
          data: JSON.stringify({
            sampleKitId: sampleKitId,
            category: category,
            action: action,
            label: label,
            value: value,
            customData: customData
          }),
          contentType: "application/json; charset=utf-8",
          dataType   : "json",
          success    : function(){
            //console.log("Pure jQuery Pure JS object");
          }
        })
      }

    }
  }();

  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = snTrackEventsModule;
  } else {
    window.snTrackEventsModule = snTrackEventsModule;
  }

})();
